<div class="bmc-event-log">
  <bz-loading [showLoading]="showLoading" [message]="loadingMessage">
  </bz-loading>
  <h5 class="bmc-event-log__title bz-space--stack-m">{{ 'EVENTS_LOG.TITLE' | translate }}</h5>
  <bz-date-filter class="bmc-event-log__range"
                  [dateMin]="state.dateMin"
                  [dateMax]="state.dateMax"
                  (onBtnFilterClick)="filterEventLogs($event)">
    <div class="bmc-event-log__level">
      <div>
        <label>{{'EVENTS_LOG.LEVELS' | translate}}</label>
      </div>
        <bzg-select [(value)]="level" class="form-control bmc-event-log__level__selector__options" id="eventLogLevel">
          <bzg-option value="All">{{'EVENTS_LOG.ALL' | translate}}</bzg-option>
          <bzg-option value="Error">{{'EVENTS_LOG.ERROR' | translate}}</bzg-option>
          <bzg-option value="FailureAudit">{{'EVENTS_LOG.FAILURE_AUDIT' | translate}}</bzg-option>
          <bzg-option value="Information">{{'EVENTS_LOG.INFORMATION' | translate}}</bzg-option>
          <bzg-option value="SuccessAudit">{{'EVENTS_LOG.SUCCESS_AUDIT' | translate}}</bzg-option>
          <bzg-option value="Warning">{{'EVENTS_LOG.WARNING' | translate}}</bzg-option>
        </bzg-select>
        <svg class="bz-icon-svg bz-icon-svg--16 bmc-event-log__level__selector__icon">
          <use href="#icon-arrow-down"></use>
        </svg>
    </div>
  </bz-date-filter>
  <div class="bmc-event-log__buttons">
    <bzg-button-secondary [icon]="'icon-download'" (click)="downloadFile()" [class.bz-btn--disabled]="downloadButtonIsDisable()" [disabled]="downloadButtonIsDisable()" class="bmc-event-log__buttons__item" title="Download event log...">
      {{textButtonExport | translate}}
    </bzg-button-secondary>
    <bzg-button-secondary (click)="refresh()" class="bmc-event-log__buttons__item" *ngIf="!downloadingFile" title="Refresh" [icon]="'icon-refresh'">
      {{'EVENTS_LOG.REFRESH' | translate}}
    </bzg-button-secondary>
  </div>
  <div class="no-records" *ngIf="(!events && !showLoading) || ((events ?  events.length ===  0 : false ) && !showLoading) ">
    <span>{{'EVENTS_LOG.NO_EVENTS' | translate}}</span>
  </div>

  <div class="blur-loading" *ngIf="showLoading" > </div>

  <ul *ngIf="((events ?  events.length >  0 : false ) )" id="divEvents" class="bz-nav-event-row ">
    <li class="bmc-event-log__summary row">
      <div class=" col-lg-1">

      </div>
      <div class="bmc-event-log__counter">
        <span class="bmc-event-log__selectedFiles"> {{numEventsToSelected() }} {{'EVENTS_LOG.ELEMENTS_SELECTED' | translate}}</span>
        <span class="bmc-event-log__results">{{'EVENTS_LOG.SHOWING' | translate}} {{ events.length }} {{'EVENTS_LOG.RESULTS' | translate}}</span>
      </div>

    </li>
  </ul>

  <thead *ngIf="((events ?  events.length >  0 : false ) )" class="bmc-event-log__table__header">
    <tr>
      <th class="bmc-event-log__table__select">
        <div class="bz-checkbox">
          <bzg-checkbox id="selectAll" class="bs-modal-fonts__checkbox" [checked]="selectAll"
            (click)="selectAllEventLogs()">
          </bzg-checkbox>
        </div>
      </th>
      <th class="bmc-event-log__table__date">
        <span>{{'EVENTS_LOG.DATE' | translate}}</span>
      </th>
      <th class="bmc-event-log__table__time">
        <span>{{'EVENTS_LOG.TIME' | translate}}</span>
      </th>
      <th class="bmc-event-log__table__source">
        <span>{{'EVENTS_LOG.SOURCE' | translate}}</span>
      </th>
      <th class="bmc-event-log__table__level">
        <span>{{'EVENTS_LOG.LEVEL' | translate}}</span>
      </th>
      <th class="bmc-event-log__table__description--title">
        <span>{{'EVENTS_LOG.DESCRIPTION' | translate}}</span>

      </th>
    </tr>
  </thead>
  <table *ngIf="((events ?  events.length >  0 : false ) )" class="bmc-event-log__table">
    <tbody class="bmc-event-log__table__body">
    <tr *ngFor="let eventlog of events; let i = index;" class="bmc-event-log__table__row">
      <td class="bmc-event-log__table__select">
        <div class="bz-checkbox">
          <bzg-checkbox id="{{i}}" class="bs-modal-fonts__checkbox" [checked]="eventlog.Selected"
            (click)="changeEventSelected(i, eventlog.Selected)">
          </bzg-checkbox>
        </div>
      </td>
      <td class="bmc-event-log__table__date">
      <span>
        {{eventlog.FormattedTimestamp | showDateFormat:2}}
      </span>
      </td>
      <td class="bmc-event-log__table__time">
        <span >
          {{eventlog.FormattedTimestamp | showDateFormat:3}}
        </span>
      </td>
      <td class="bmc-event-log__table__source">
      <span>
        {{eventlog.Source}}
      </span>
      </td>
      <td class="bmc-event-log__table__level">
      <span>
        {{eventlog.Type}}
      </span>
      </td>
      <td>
        <p class="bmc-event-log__table__description bmc-event-log__table__description--ellipsips log-entry"
          (click)="eventlog.Seletected = !eventlog.Seletected">
          <span class="bmc-event-log__table__description__text" [ngClass]="{'bmc-event-log__table__description__text-normal': eventlog.Seletected}"> {{eventlog.LogEntry}}</span>
          <svg class="bz-icon-svg bz-icon-svg--16 bmc-event-log__table__description__icon">
            <use *ngIf="eventlog.Seletected" href="#arrow-up"></use>
            <use *ngIf="!eventlog.Seletected" href="#arrow-down"></use>
          </svg>
        </p>
      </td>
    </tr>
    </tbody>
  </table>
  <hr class="bmc-event-log__table__border-bottom">
  <div class="bmc-event-log__table__btn-load-more">
    <bzg-button-secondary *ngIf="hasMoreResults && !showLoading" (click)="getEventLogDetails()">{{'EVENTS_LOG.LOAD_MORE' | translate}}</bzg-button-secondary>
  </div>

</div>
